<script>
  import { toJSDate } from "../../../../Controller/analytics/toJSDate";
    import { Analytics } from "./../../../../Controller/analytics/pedidos/pedidos.js";
    import Respuestas from "./../models/respuestas.svelte";
    import Tendencias from "./../models/tendencias.svelte";


    import TablaComentarios from "./../models/tablaComenarios.svelte";

    import mainViewAnalytics from "../../../../Controller/analytics/viewMain.js";

    import { createEventDispatcher } from "svelte";

    import { createNewDate } from "../../../../Controller/APIs/date";

     import { modelValid } from "../../../../Models/modelSystemG.js";

    const dispatch = createEventDispatcher();
    let tab;
    let tarjetaPromedio,
        tarjetaRatings,
        tarjetaTime,
        intervalosTiempo,
        tendenciasMesas,
        cuestionario,
        comentarios;

    export let data = [];
    export let view_analytics;

    let dataView = {
        btnopceye: false,
    };

    main();
    function main() {
        if (data.length == 0) {
            return;
        }

        tab = new mainViewAnalytics(view_analytics.service);
        tab._main();
        setdata();
        dataView.eye = Array.from({ length: data.length }, (_, i) => false);
    }

    async function del(i, date) {
        if (!window.confirm("¿Eliminar esta respuesta?")) return;
        let document = [];
        data.forEach((item) => {
            if (
                tab.timestampToDate(item.date).getMonth() ===
                    tab.timestampToDate(date).getMonth() &&
                tab.timestampToDate(item.date).getFullYear() ===
                    tab.timestampToDate(date).getFullYear()
            ) {
                if (item.date == date) {
                    return;
                }
                document.push(item);
            }
        });
        let newdate = await createNewDate();
        if (
            newdate.year == tab.timestampToDate(date).getFullYear() &&
            newdate.month == tab.timestampToDate(date).getMonth() + 1
        ) {
            view_analytics.service.listRatinggs[
                view_analytics.index
            ].analytics.coleccion = document;
            await modelValid({
                doc: "updateService",
            });
        }
        if (
            !(
                newdate.year == tab.timestampToDate(date).getFullYear() &&
                newdate.month == tab.timestampToDate(date).getMonth() + 1
            )
        ) {
            await tab.model_Analytics.Crear({
                id: view_analytics.dataListService.analytics.idDoc,
                y: tab.timestampToDate(date).getFullYear().toString(),
                m: tab.timestampToDate(date).getMonth().toString(),
                data: document,
            });
        }
        data.splice(i, 1);
        view_analytics.setDataopc(data);
        dispatch("set_data", { data });
    }

    function resp_view(index) {
        if (dataView.eye[index]) {
            dataView.eye[index] = false;
            return;
        }

        tab.setDataopc([data[index]]);

        if (dataView.eye[index] == false) {
            dataView.eye = Array.from({ length: data.length }, (_, i) => false);
            dataView.eye[index] = true;
        }
        setdata();
    }

    function setdata() {
        comentarios = [];
        /* Tarjetas */
        tarjetaPromedio = tab.tarjetaPromedio;
        tarjetaRatings = tab.tarjetaRatings;
        tarjetaTime = tab.tarjetaTime;

        /* Panel */
        intervalosTiempo = tab.intervalosTiempo;
        tendenciasMesas = tab.promMesa;

        /* Respuestas */
        cuestionario = tab.cuestionarios;

        /* comentarios */
        comentarios = tab.comentarios;
    }
</script>

<section class="resp">
    <button
        type="button"
        class="resp-head"
        aria-expanded={dataView.btnopceye}
        on:click={() => (dataView.btnopceye = !dataView.btnopceye)}
    >
        <h3 class="resp-title">Respuestas</h3>
        <span class="count">{data.length}</span>
        <svg class="chev" class:open={dataView.btnopceye} viewBox="0 0 24 24" aria-hidden="true">
            <path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </button>

    {#if dataView.btnopceye}
        {#if data.length === 0}
            <p class="resp-empty">Sin respuestas en este periodo.</p>
        {:else}
            <ul class="resp-list">
                {#each data as resp, index}
                    <li class="resp-item">
                        <div class="resp-row">
                            <div class="resp-main">
                                <span class="resp-who">{resp.user.status ? resp.user.name : "Anónimo"}</span>
                                <span class="resp-meta">
                                    {toJSDate(resp.date).toLocaleDateString()}
                                    {toJSDate(resp.date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                                    · Mesa {resp.mesa}
                                </span>
                            </div>
                            <button
                                type="button"
                                class="icon-btn danger"
                                aria-label="Eliminar respuesta"
                                on:click={() => del(index, resp.date)}
                            >
                                <svg viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                            <button
                                type="button"
                                class="icon-btn"
                                aria-label={dataView.eye[index] ? "Contraer detalle" : "Expandir detalle"}
                                aria-expanded={!!dataView.eye[index]}
                                on:click={() => resp_view(index)}
                            >
                                <svg class="chev" class:open={dataView.eye[index]} viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>

                        {#if dataView.eye[index]}
                            <div class="detail">
                                <p class="detail-summary">
                                    Tiempo de atención <strong>{tarjetaPromedio.value}</strong>
                                    · Satisfacción <strong>{tarjetaTime.value}</strong>
                                </p>
                                <div class="detail-grid">
                                    <Tendencias data={intervalosTiempo} />
                                    <Tendencias data={tendenciasMesas} kind="bar" />
                                    {#each cuestionario as element}
                                        <Respuestas
                                            data_PolarArea={element.polar}
                                            data_line={element.line}
                                            name={element.pregunta}
                                        />
                                    {/each}
                                </div>
                                {#if comentarios.length > 0}
                                    <div class="detail-comments">
                                        <TablaComentarios data={comentarios} />
                                    </div>
                                {/if}
                            </div>
                        {/if}
                    </li>
                {/each}
            </ul>
        {/if}
    {/if}
</section>

<style>
    .resp {
        background: #fbf6ea;
        border: 1px solid rgba(44, 51, 32, 0.08);
        border-radius: 18px;
        box-shadow: 0 1px 2px rgba(42, 42, 28, 0.06),
            0 12px 28px -12px rgba(42, 42, 28, 0.18);
    }

    .resp-head {
        display: flex;
        align-items: center;
        gap: 0.6rem;
        width: 100%;
        padding: 0.85rem 1.1rem;
        border: 0;
        background: transparent;
        text-align: left;
        color: #2c3320;
    }

    .resp-title {
        flex: 1;
        margin: 0;
        font-family: "Fraunces", ui-serif, Georgia, serif;
        font-weight: 600;
        font-size: 1rem;
    }

    .count {
        font-size: 0.75rem;
        font-weight: 700;
        color: #57543f;
        background: #e4ebce;
        border-radius: 999px;
        padding: 0.05rem 0.55rem;
    }

    .chev {
        width: 18px;
        height: 18px;
        flex: none;
        color: #57543f;
        transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    }

    .chev.open {
        transform: rotate(180deg);
    }

    .resp-head:focus-visible,
    .icon-btn:focus-visible {
        outline: 2px solid #ce5b34;
        outline-offset: -2px;
    }

    .resp-empty {
        margin: 0;
        padding: 0 1.1rem 1rem;
        font-size: 0.85rem;
        color: #83805f;
    }

    .resp-list {
        list-style: none;
        margin: 0;
        padding: 0 0.6rem 0.4rem 1.1rem;
    }

    .resp-item {
        border-top: 1px solid rgba(44, 51, 32, 0.1);
    }

    .resp-row {
        display: flex;
        align-items: center;
        gap: 0.25rem;
        padding: 0.45rem 0;
    }

    .resp-main {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        line-height: 1.25;
    }

    .resp-who {
        font-weight: 600;
        font-size: 0.9rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .resp-meta {
        font-size: 0.75rem;
        color: #83805f;
    }

    .icon-btn {
        flex: none;
        width: 40px;
        height: 40px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 0;
        border-radius: 10px;
        background: transparent;
        color: #57543f;
    }

    .icon-btn:hover {
        background: #e4ebce;
    }

    .icon-btn.danger:hover {
        background: #f8d9c6;
        color: #b14b2c;
    }

    .icon-btn svg {
        width: 18px;
        height: 18px;
    }

    .detail {
        padding: 0.25rem 0.5rem 1rem 0;
    }

    .detail-summary {
        margin: 0 0 0.6rem;
        font-size: 0.8rem;
        color: #57543f;
    }

    .detail-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(min(100%, 320px), 1fr));
        gap: 0.75rem;
    }

    .detail-grid > :global([class*="col-"]) {
        flex: none;
        width: auto;
        max-width: none;
        padding: 0;
    }

    .detail-comments {
        margin-top: 0.75rem;
    }

    @media (prefers-reduced-motion: reduce) {
        .chev {
            transition: none;
        }
    }
</style>
